module.exports = __webpack_public_path__ + "img/call-center-ac.19e674c3.png";